import {
  RefurbishedStockHistoryItem,
  RefurbishedStockRecord,
  StockReference,
} from "../../api/refurbishedStock.api";

export const canMarkRefurbished = (record: RefurbishedStockRecord) =>
  record.status === "needs_repair" && !record.dispatchedDate;

export const getStockReferenceLabel = (reference?: StockReference) => {
  if (!reference) return "";
  if (typeof reference === "string") return reference;
  return (
    reference.name ||
    reference.productName ||
    reference.username ||
    reference.fullName ||
    reference.orderNumber ||
    ""
  );
};

const getHistoryTime = (item: RefurbishedStockHistoryItem) => {
  const date =
    item.date || item.createdAt || item.timestamp || item.performedAt;
  return date ? Date.parse(date) : Number.NaN;
};

export const sortReplacementStockHistory = (
  history: RefurbishedStockHistoryItem[] = [],
) =>
  history
    .map((item, index) => ({ item, index, time: getHistoryTime(item) }))
    .sort((left, right) => {
      if (Number.isNaN(left.time) && Number.isNaN(right.time)) {
        return left.index - right.index;
      }
      if (Number.isNaN(left.time)) return 1;
      if (Number.isNaN(right.time)) return -1;
      return left.time - right.time;
    })
    .map(({ item }) => item);

export const formatStockDate = (
  value?: string | null,
  includeTime = false,
) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(includeTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  };
  return includeTime
    ? date.toLocaleString("en-GB", options)
    : date.toLocaleDateString("en-GB", options);
};
